import i18next from 'i18next';

/** The UI language for data written in it (labels of new generic objects, OIL-121). */
export function uiLocale(): 'en' | 'de' {
  return i18next.language?.startsWith('de') ? 'de' : 'en';
}

/**
 * A point in time as the app shows it everywhere: short date + short time in the UI language
 * ("12.10.26, 17:17" / "10/12/26, 5:17 PM"), no seconds (OIL-230).
 */
export function formatDateTime(iso: string, language: string): string {
  return new Date(iso).toLocaleString(language, { dateStyle: 'short', timeStyle: 'short' });
}
